export const ACTION_EXPIRED = 'expired';
export const ACTION_LOGIN = 'login';
export const ACTION_LOGOUT = 'logout';
